import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as DependenciesV2Store from '../../../../redux/dependenciesV2';
import { selectOptionFactory } from '../../../../utils';
import type { SelectOption } from '../../../../types';

/**
 * Fetches the list of relevant root packages whenever the current scope changes.
 */
const useRootProjects = (): {
  areRootProjectsLoading: boolean;
  rootProjects: SelectOption[];
} => {
  const dispatch = useDispatch();

  const areRootProjectsLoading = useSelector(DependenciesV2Store.selectors.getAreRootProjectsLoading);
  const rootProjects = useSelector(DependenciesV2Store.selectors.getRootProjects);

  // fetch updated root projects whenever the current scope changes
  const scope = useSelector(DependenciesV2Store.selectors.getScope);
  useEffect(() => {
    if (!scope || scope.scope !== 'releaseGroup') {
      return;
    }

    dispatch(DependenciesV2Store.actions.fetchRootProjectsAction(scope));
  }, [dispatch, scope]);

  // convert available root projects to SelectOptions
  const options = rootProjects.map((project) => selectOptionFactory(project.revision, project.title));

  return {
    areRootProjectsLoading,
    rootProjects: options,
  };
};

export default useRootProjects;
